import { Injectable, EventEmitter } from '@angular/core'
import { M3Procesos } from '../Registro/m3-procesos';
import PouchDB from 'pouchdb';
import 'rxjs/add/operator/map';

@Injectable({
    providedIn: 'root'
})
export class M3CouchMaestro {
    public oDataM3Procesos: M3Procesos;

    private isInstantiated: boolean;
    private database: any;
    private listener: EventEmitter<any> = new EventEmitter();

    constructor() {
        if (!this.isInstantiated) {
            var sIdkatios: string;
            var sTipoHub: string;
            sIdkatios = this.GetIdKatiosLVL1FromSession();
            sTipoHub = this.GetTipoHubFromSession();
            if (sIdkatios) {
                if (sTipoHub && sTipoHub.toUpperCase().trim() == "WEB") {
                    this.database = new PouchDB("infomEcc_" + sIdkatios.toLowerCase().trim(), { auto_compaction: true });
                    this.sync(this.GetServer() + "infomEcc_" + sIdkatios.toLowerCase().trim());
                    this.isInstantiated = true;
                    console.log("INSTANCEECC!!Â¡")
                }
                else {
                    this.database = new PouchDB("infom_" + sIdkatios.toLowerCase().trim(), { auto_compaction: true });
                    this.sync(this.GetServer() + "infom_" + sIdkatios.toLowerCase().trim());
                    this.isInstantiated = true;
                    console.log("INSTANCE!!Â¡")
                }
            }
        }
    }

    //Funcion que traera el tipo de hub
    public GetTipoHubFromSession() {
        var sSUbicacion = sessionStorage.getItem("SUbicacion");
        var oSUbicacion;
        if (sSUbicacion) {
            oSUbicacion = JSON.parse(sSUbicacion);
            if (oSUbicacion.M3HUBS && oSUbicacion.M3HUBS[0] && oSUbicacion.M3HUBS[0].Tipo) {
                return oSUbicacion.M3HUBS[0].Tipo;
            }
        }
        return null;
    }

    //Idkatios que se carga, cuando se inicia el redireccionamiento hacia el WE8
    public GetIdKatiosLVL1FromSession() {
        var sSessionLVL1M3 = sessionStorage.getItem("SessionLVL1M3");
        var oSessionLVL1M3;
        if (sSessionLVL1M3 !== undefined && sSessionLVL1M3 != null) {
            oSessionLVL1M3 = JSON.parse(sSessionLVL1M3);
            if (oSessionLVL1M3.UsuarioSistema.IDKATIOS !== undefined && oSessionLVL1M3.UsuarioSistema.IDKATIOS != null) {
                return oSessionLVL1M3.UsuarioSistema.IDKATIOS;
            }
        }
        return null;
    }

    public GetServer(): string {
        //var json = require('../../../assets/Config/config.json');
        var json = require('G:/Desarrollo/BD/WE8/config.json');
        return json.CouchDBM3;
    }

    public get(id: string) {
        return this.database.get(id);
    }

    //Obtener informacion de base de datos.
    public GetDataPouchBD(isKey: string) {
        return this.database.get(isKey);
    }


    public getChangeListener() {
        return this.listener;
    }

    public sync(remote: string) {
        // let remoteDatabase = new PouchDB(remote);

        // let options = {
        //     retry: true
        // };

        // let options2 = {
        //     live: true,
        //     retry: true
        // };

        // //this.autenticacionServer(remoteDatabase);
        // this.database.sync(remoteDatabase, {
        //     options2
        // }).on('complete', change => {
        //     console.log("Completo:" + change)
        // }).on('change', change => {
        //     this.listener.emit(change);
        // }).on('error', error => {
        //     this.database.sync(remoteDatabase, options2);
        // });


        let remoteDatabase = new PouchDB(remote, { auto_compaction: true });

        this.database.replicate.from(remoteDatabase, {
            live: true,
            retry: true
        }).on('complete', change => {

            console.log("********************************** COMPLETO CAMBIO PROMOCIONES *****************************************")
        }).on('change', change => {
            this.listener.emit(change);
            console.log("********************************** CHANGE CAMBIO PROMOCIONES *****************************************")
        }).on('error', function (err) {
            console.log("Error")
            // boo, something went wrong!
        });
    }

    //armar key de documento que se quiere consultar
    public GetKeyDocumentoDB(isIDKatios: string, isDocumento: string) {
        return isIDKatios + "?" + isDocumento;
    }


}
